// const calpak = window.calpak

document.addEventListener("calpak:ready", function (e) {
    const featuresTitles = document.querySelectorAll('.pdp-feature__title');
    featuresTitles.forEach(featuresTitle => featuresTitle.addEventListener('click', (e) => {
        e.preventDefault();
        const target = e.target;
        const prnt = target.closest('.pdp-features');
        const feat = target.closest('.pdp-feature');
        const active = feat.parentNode.querySelector('.pdp-feature--active');
        
        const fitTitle = document.querySelector(".pdp-features__subheading");
        if(!feat.classList.contains("pdp-feature--main"))
            if(fitTitle != null)
                fitTitle.classList.remove('active');
        const index = calpak.getIndex(feat);

        const activeMedia = prnt.querySelector('.pdp-feature__media--active');

        if (activeMedia) {
            activeMedia.classList.remove('pdp-feature__media--active');
            activeMedia.removeAttribute('aria-current');
        }

        prnt.querySelectorAll('.pdp-feature__media')[index].classList.add('pdp-feature__media--active');
        prnt.querySelectorAll('.pdp-feature__media')[index].setAttribute('aria-current', true);

        if (active) {
            active.classList.remove('pdp-feature--active');
            active.querySelector('.pdp-feature__title')?.removeAttribute('aria-current');
        }

        feat.classList.add('pdp-feature--active');
        if (target.classList.contains('pdp-feature__title')) {
            target.setAttribute('aria-current', true);
        } else if (target.parentNode.classList.contains('pdp-feature__title')) {
            target.parentNode.setAttribute('aria-current', true);
        }
    }));

    if(document.querySelector('.pdp-features.single')) {
        const pdpFeaturesContainer = document.querySelector('.pdp-features.single');
        pdpFeaturesContainer.querySelectorAll('.pdp-features.single .pdp-compare-feature__title').forEach(compareFeaturesTitle => compareFeaturesTitle.addEventListener('click', (e) => {
            e.preventDefault();
            pdpFeaturesContainer.querySelector('.pdp-compare-feature--active').classList.remove("pdp-compare-feature--active");
            compareFeaturesTitle.parentElement.classList.add("pdp-compare-feature--active");
            compareFeaturesTitle.setAttribute('aria-current', true);
            const handle = compareFeaturesTitle.getAttribute('data-handle');
            pdpFeaturesContainer.querySelectorAll(`.pdp-feature`).forEach(feature => feature.classList.add('hidden'));
            const featuresTitles = pdpFeaturesContainer.querySelectorAll(".pdp-feature.pdp-feature--" + handle);
            featuresTitles.forEach(featuresTitle => {featuresTitle.classList.remove('hidden')});
            pdpFeaturesContainer.querySelector(`.pdp-feature.pdp-feature--active`).classList.remove('pdp-feature--active');
            pdpFeaturesContainer.querySelector(".pdp-feature--" + handle).classList.add('pdp-feature--active');
            pdpFeaturesContainer.querySelector(`.pdp-feature__media.pdp-feature__media--active`).classList.remove('pdp-feature__media--active');
            pdpFeaturesContainer.querySelector(".pdp-feature__media--" + handle).classList.add('pdp-feature__media--active');
            const fitTitle = document.querySelector(".pdp-features__subheading");
            if(fitTitle != null)
                fitTitle.classList.add('active');
        }))
    }

    if(document.querySelector('.pdp-features.bundle')) {
        const pdpFeaturesContainer = document.querySelector('.pdp-features.bundle');
        pdpFeaturesContainer.querySelectorAll('.pdp-features.bundle .pdp-compare-feature__title').forEach(compareFeaturesTitle => compareFeaturesTitle.addEventListener('click', (e) => {
            e.preventDefault();
            pdpFeaturesContainer.querySelector('.pdp-compare-feature--active').classList.remove("pdp-compare-feature--active");
            compareFeaturesTitle.parentElement.classList.add("pdp-compare-feature--active");
            compareFeaturesTitle.setAttribute('aria-current', true);
            const handle = compareFeaturesTitle.getAttribute('data-handle');
            pdpFeaturesContainer.querySelectorAll(`.pdp-features__list-item`).forEach(feature => feature.classList.add('hidden'));
            pdpFeaturesContainer.querySelectorAll(".pdp-feature").forEach(feature => feature.classList.add('hidden'));
            const featuresTitles = pdpFeaturesContainer.querySelectorAll(".pdp-features__list-item.pdp-features__list-item--" + handle);
            const fitTitle = document.querySelector(".pdp-features__subheading");
            if(fitTitle != null)
                fitTitle.classList.add('active');
            featuresTitles.forEach((featuresTitle, index) => {
                featuresTitle.classList.remove('hidden');
                if(index === 0) {
                    featuresTitle.querySelector("button").click();
                }
            });
        }))
        pdpFeaturesContainer.querySelectorAll(".pdp-features__list-item button").forEach(button => button.addEventListener('click', (e) => {
            e.preventDefault();
            pdpFeaturesContainer.querySelectorAll(".pdp-features__list-item").forEach(item=>item.classList.remove("active"));
            button.parentElement.classList.add("active");
            const buttonHandle = button.getAttribute('data-handle');
            const productHandle = button.getAttribute('data-product');
            const bundleHandle = button.getAttribute('data-sub-product');
            pdpFeaturesContainer.querySelectorAll(".pdp-feature").forEach(feature => feature.classList.add('hidden'));
            const fitTitle = document.querySelector(".pdp-features__subheading");
            if(buttonHandle == "backpack")
            {
                if(fitTitle != null){
                    fitTitle.classList.remove("hidden");
                    fitTitle.classList.add("active");
                }
                pdpFeaturesContainer.querySelector(".pdp-compare-features__list").classList.remove("hidden");
            }else{
                pdpFeaturesContainer.querySelector(".pdp-compare-features__list").classList.add("hidden");
                if(fitTitle != null)
                    fitTitle.classList.add("hidden");
            }
            pdpFeaturesContainer.querySelectorAll(`.pdp-feature.pdp-feature--${productHandle}--${bundleHandle}`).forEach((feature, index) => {
                feature.classList.remove('hidden')
                if(index === 0) {
                    feature.querySelector("button").click();
                }
            });
        }))
    }

});
